import React, { ReactNode } from 'react';
import scssObj from './_InteractiveCards.scss';
import Card from '@mui/material/Card';
import { CardActionArea } from '@mui/material';

interface Props {
  /**
   * Colour for extention of images to be looked complete and all occupied
   */
  backGroundColor: string;
  backGroundImageLink: string;
  /**
   * Colour of the background behind the non-hover material
   */
  backGroundColour: string;
  nonHoverContent: ReactNode;
  hoverContent: ReactNode;
}

function InteractiveCards({
  backGroundColor,
  backGroundImageLink,
  backGroundColour,
  nonHoverContent,
  hoverContent,
}: Props) {
  return (
    <div className={`${scssObj.baseClass}__container`}>
      <Card className={`${scssObj.baseClass}__main-card`}>
        <CardActionArea className={`${scssObj.baseClass}__action-card`}>
          <div
            className={`${scssObj.baseClass}__non-hover-variable`}
            style={{
              backgroundColor: backGroundColor,
              backgroundImage: `url('${backGroundImageLink}')`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            <div
              className={`${scssObj.baseClass}__faint-backgrounder`}
              style={{ backgroundColor: backGroundColour }}
            >
              {nonHoverContent}
            </div>
          </div>

          <div className={`${scssObj.baseClass}__hover-variable`}>
            {hoverContent}
          </div>
        </CardActionArea>
      </Card>
    </div>
  );
}

export default InteractiveCards;
